module.exports = __webpack_public_path__ + "img/linkedin.d330209c.svg";